/*
 * La molette d'un input number change sa valeur.
 * L'événement React onWheel est passif : preventDefault n'y a aucun effet.
 * On annule donc le pas au niveau du document, puis on défile le conteneur
 * nous-mêmes, un peu plus court qu'un cran natif.
 */

const SCROLL_FACTOR = 0.45;

let installed = false;

function scrollableAncestor(element: HTMLElement): HTMLElement | Window {
	let parent = element.parentElement;
	while (parent) {
		const overflowY = getComputedStyle(parent).overflowY;
		if (
			(overflowY === 'auto' || overflowY === 'scroll') &&
			parent.scrollHeight > parent.clientHeight
		) {
			return parent;
		}
		parent = parent.parentElement;
	}
	return window;
}

function wheelDistance(event: WheelEvent): number {
	let delta = event.deltaY;
	if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 16;
	if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
		delta *= window.innerHeight;
	}
	return delta * SCROLL_FACTOR;
}

function onWheel(event: WheelEvent): void {
	const target = event.target;
	if (!(target instanceof HTMLInputElement) || target.type !== 'number') {
		return;
	}
	if (document.activeElement !== target) return;

	event.preventDefault();
	const scroller = scrollableAncestor(target);
	const distance = wheelDistance(event);
	if (scroller === window) {
		window.scrollBy(0, distance);
	} else {
		scroller.scrollBy(0, distance);
	}
}

export function installNumberInputWheelGuard(): void {
	if (installed) return;
	installed = true;
	document.addEventListener('wheel', onWheel, {
		capture: true,
		passive: false,
	});
}
